import { trackingTextRuleSchema } from "@redotech/redo-order-tracking-settings-common/tracking-text-rule";
import * as z from "zod";

export const OrderTrackingSettingsFlatTeamSettingsSchema = z.object({
  "checkoutDeliveryEstimates/enabled": z.boolean().nullish(),
  "orderTracking/textRules": z.array(trackingTextRuleSchema).nullish(),
  "orderTracking/stalledDays": z.number().nullish(),
  "orderTracking/stalledDaysFulfillment": z.number().nullish(),
  "orderTracking/v2/excludeSaturdayTransit": z.boolean().nullish(),
  "orderTracking/v2/excludeSundayTransit": z.boolean().nullish(),
  "orderTracking/v2/excludeSaturdayFulfillment": z.boolean().nullish(),
  "orderTracking/v2/excludeSundayFulfillment": z.boolean().nullish(),
  "orderTracking/v2/orderExclusionRules": z
    .array(
      z.object({
        checks: z
          .array(
            z.object({
              field: z.string().nullish(),
              operator: z.string().nullish(),
              value: z.string().nullish(),
            }),
          )
          .nullish(),
      }),
    )
    .nullish(),
  "orderTracking/carrierMappings": z
    .array(
      z.object({
        value: z.string().nullish(),
        matchType: z.string().nullish(),
        targetCarrier: z.string().nullish(),
        trackingCode: z
          .object({
            value: z.string().nullish(),
            matchType: z.string().nullish(),
          })
          .nullish(),
      }),
    )
    .nullish(),
  "orderTracking/weeklyAnalyticsEmail/enabled": z.boolean().nullish(),
  "orderTracking/weeklyAnalyticsEmail/recipientEmails": z
    .array(z.string())
    .nullish(),
});
